import React from 'react';
import { withRouter, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import CookieConsent from './components/elements/CookieConsent';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';
import LayoutAlternative from './layouts/LayoutAlternative';
import LayoutSignin from './layouts/LayoutSignin';

// Views 
import Home from './views/Home';
import Secondary from './views/Secondary';
import Login from './views/Login';
import Signup from './views/Signup';
import ScriptoresSandbox from './views/ScriptoresSandbox';

class App extends React.Component {

  componentDidMount() {
    document.body.classList.add('is-loaded')
    this.refs.scrollReveal.init();
    this.handleHashScroll();
  }

  // Route change
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.refs.scrollReveal.init();
      // Scroll to top when navigating to a new route
      window.scrollTo(0, 0);
    }
    // Handle hash scrolling on home page
    if (this.props.location.pathname === '/' && window.location.hash && window.location.hash !== '#/') {
      this.handleHashScroll();
    }
  }

  handleHashScroll = () => {
    // Check if we're on home page and there's a hash in the URL
    if (this.props.location.pathname === '/' && window.location.hash) {
      const hash = window.location.hash.replace('#/', '').replace('#', '');
      if (hash && hash !== '/') {
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 300);
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <ScrollReveal
          ref="scrollReveal"
          children={() => (
            <Switch>
              <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
              <AppRoute exact path="/secondary" component={Secondary} layout={LayoutAlternative} />
              <AppRoute exact path="/login" component={Login} layout={LayoutSignin} />
              <AppRoute exact path="/signup" component={Signup} layout={LayoutSignin} />
              <AppRoute exact path="/scriptores_sandbox" component={ScriptoresSandbox} layout={LayoutDefault} />
            </Switch>
          )} />
        <CookieConsent />
      </React.Fragment>
    );
  }
}

export default withRouter(props => <App {...props} />);